import { Stack } from '@mui/material';
import { BaseField } from '../../../components/fields/BaseField.tsx';

const validateExternalDatabaseUrl = (url?: string | null) => {
  if (!url || url.trim() === '') {
    return true;
  }

  try {
    const urlObj = new URL(url);
    if (urlObj.protocol !== 'https:') {
      return 'HTTPSのURLを入力してください';
    }
    return true;
  } catch {
    return '有効なURLを入力してください';
  }
};

const EXTERNAL_DATABASE_FIELDS = [
  { name: 'tkcLawLibraryUrl', label: 'TKCローライブラリー' },
  { name: 'westlawJapanUrl', label: 'Westlaw Japan' },
  { name: 'shojiHomuDbUrl', label: '商事法務データベース' },
  { name: 'junkanShojiHomuDbUrl', label: '旬刊商事法務データベース' },
] as const;

export const ExternalDatabaseUrlField = () => {
  return (
    <Stack spacing={2}>
      {EXTERNAL_DATABASE_FIELDS.map(({ name, label }) => (
        <BaseField
          key={name}
          name={name}
          label={label}
          rules={{
            validate: (value) => validateExternalDatabaseUrl(value),
          }}
          fullWidth
        />
      ))}
    </Stack>
  );
};
